import {
  BUY_PRODUCT_FAILED,
  BUY_PRODUCT_INVALID_REQUEST,
  BUY_PRODUCT_INVALID_TYPE,
  BUY_PRODUCT_SUCCESS,
  BUY_PRODUCT_OPERATION_NOT_PERMITTED,
  RESET_BUY_PRODUCT,
  LOADING_BUY_PRODUCT,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  success: false,
  operationNotPermitted: false,
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_BUY_PRODUCT:
      return {
        ...state,
        isLoading: true,
        failed: false,
        invalidRequest: false,
        operationNotPermitted: false,
        success: false,
      };
    case BUY_PRODUCT_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: true,
        operationNotPermitted: false,
        status: "Your order was unsuccessfull!",
        data: action.payload,
      };
    case BUY_PRODUCT_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        operationNotPermitted: false,
        status: "Oops!, Something went wrong",
        data: action.payload,
      };

    case BUY_PRODUCT_INVALID_TYPE:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: true,
        operationNotPermitted: false,
        status: "Your order was unsuccessfull!",
        data: action.payload,
      };

    case BUY_PRODUCT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        operationNotPermitted: false,
        status: "Your order was placed successfully!",
        data: action.payload,
      };

    case BUY_PRODUCT_OPERATION_NOT_PERMITTED:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidRequest: false,
        operationNotPermitted: true,
        status: "Operation Not Permitted",
        data: action.payload,
      };

    case RESET_BUY_PRODUCT:
      return (state = initialState);

    default:
      return state;
  }
};
